import { memo } from 'react'
import { FromTip } from './styles'
import { Space4 } from '../../styles'
import { useParams } from 'react-router-dom'
import { useIsDepositPage } from '../../store/deposit/hook'
import { StyledControlInputLarge } from '../../styles/Control'

export const DepositToAddress = memo(() => {
  const params = useParams<{ address: string }>()
  const isDepositPage = useIsDepositPage()

  // If the access route is not '/deposit/:address',
  // it is the deposit pop-up modal,
  // so do not display the depositTo address,
  // because it is depositing to the user's own address
  if (!isDepositPage) return null

  // If the access route is '/deposit/:address',
  // then display the depositTo address(:address).
  // The :address can be anyone address.
  return (
    <>
      <FromTip>Deposit To</FromTip>
      <Space4 />
      <StyledControlInputLarge
        style={{
          overflow: 'hidden',
          wordWrap: 'break-word',
          wordBreak: 'break-all',
          height: 'unset',
          padding: '12px',
          fontSize: '12px',
        }}
      >
        {params?.address}
      </StyledControlInputLarge>
      <Space4 />
    </>
  )
})
